var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.063,
    height: 13.185,
    viewBox: "0 0 17.063 13.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3006",
    "data-name": "Rectangle 3006",
    width: 17.063,
    height: 13.185,
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9681",
    "data-name": "Group 9681",
    transform: "translate(0 0.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9680",
    "data-name": "Group 9680",
    transform: "translate(0 -0.197)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26701",
    "data-name": "Path 26701",
    d: "M15.793,13.032H1.215A1.216,1.216,0,0,1,0,11.817V.554C0,.542,0,.529,0,.517H0A.549.549,0,0,1,.12.207Q.136.189.152.171h0A.55.55,0,0,1,.543,0H16.465a.551.551,0,0,1,.391.171h0l.031.036a.549.549,0,0,1,.12.31h0c0,.012,0,.024,0,.036V11.817a1.216,1.216,0,0,1-1.215,1.215m-13.821-1.1H15.037L9.95,7.265l-1.073.983a.553.553,0,0,1-.746,0L7.058,7.265ZM1.1,1.807v9.418L6.241,6.516Zm9.663,4.709L15.9,11.224V1.807Zm-3.328-.4L8.5,7.092l1.065-.976L9.585,6.1l5.451-5H1.972l5.451,5,.017.015",
    transform: "translate(0 0.153)",
    fill: "#2e728c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.4604b0863c4594eb0bde490aa51ecda7.svg";
export { ForwardRef as ReactComponent };